export const validators = {
    required(v, fieldName = 'Field') {
        return !!v || v === 0 || fieldName + ' is required';
    },

    email(v) {
        return /.+@.+/.test(v) || 'E-mail must be valid';
    },

    minLength(v, min) {
        return (v && v.length >= min) || 'Password must be at least ' + min + ' characters';
    },
};
